import React, { useState } from 'react';
import { Header, Icon, Loader, Message } from 'semantic-ui-react';
import type { FlatPatient } from 'types';

import { useGetZoomCommunications } from './hooks';
import ZoomTable from './zoomTable';
type ZoomProps = {
  /**
   * `| undefined` rather than a bare `?:` because the tab hub forwards its own
   * optional `patient` as a JSX attribute — under `exactOptionalPropertyTypes`
   * that is a *pass of `undefined`*, not an omission, and a plain `?:` rejects
   * it. The component already destructures with `flatPatient || {}`, so the
   * absent case was always handled.
   */
  flatPatient?: FlatPatient | undefined;
};
const Zoom: React.FC<ZoomProps> = ({ flatPatient }) => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [_isRefreshLoading, setIsRefreshLoading] = useState<boolean>(false);

  const { id } = flatPatient || {};

  const { communicationsData, communicationsError, communicationsMutate, isLoading } = useGetZoomCommunications({
    patientId: id,
  });

  const handleErrorMessage = (errorString: string) => {
    setErrorMessage(errorString);
  };

  const _handleRefresh = async () => {
    setIsRefreshLoading(true);

    await communicationsMutate();

    setIsRefreshLoading(false);
  };
  return (
    <div>
      <Header as="h3" color="blue">
        <Icon name="video" size="mini" color="blue" />
        <Header.Content>Zoom Communications</Header.Content>
      </Header>
      {isLoading && <Loader active inline="centered" />}
      {communicationsData && !communicationsData.entry && (
        <Message content="No Zoom communications found." header="Info" warning />
      )}
      {errorMessage && (
        <Message content={errorMessage} onDismiss={() => handleErrorMessage('')} negative size="small" />
      )}
      {communicationsError && !isLoading && (
        <Message negative>
          <Message.Header>Oops! Something went wrong.</Message.Header>
          <p>{communicationsError}</p>
        </Message>
      )}
      {communicationsData && communicationsData.entry && !isLoading && (
        <ZoomTable
          debugCommunications={communicationsData}
          communicationsMutate={communicationsMutate}
          handleErrorMessage={handleErrorMessage}
        />
      )}
    </div>
  );
};

export default Zoom;
